import { useCallback, useMemo } from 'react';

import { StaticImages } from '@/modules/events/views/EventEditor/components/AddCover/const';

import { CoverType, UseImageListProps } from '../types';

export const RANDOM_CARD_NAME = 'randomCardItem';
const UPLOAD_CARD_ITEM = { url: '', name: '' };
const RANDOM_CARD_ITEM = { url: 'randomUrl', name: RANDOM_CARD_NAME }; //needed as url being used to identify selected cards

const useImageList = ({
  data,
  searchString,
  items,
  selectedCard,
  showRandom,
  setCard,
  showUploadCard,
  staticImageType,
}: UseImageListProps) => {
  const onClickCard = useCallback(
    (card: CoverType) => {
      if (card.name === RANDOM_CARD_NAME) {
        const randomItem = data[Math.floor(Math.random() * data.length)];
        setCard(randomItem);
        return;
      }

      if (!card.url) {
        return;
      }

      selectedCard?.url === card.url
        ? setCard({ url: '', name: '' })
        : setCard({ ...card, name: card.name || 'Image' }); //when name in unsplash image is null
    },
    [data, selectedCard.url, setCard],
  );

  const staticImage = useMemo(() => {
    const staticImage = (staticImageType && StaticImages?.[staticImageType]) ?? [];
    return staticImage;
  }, [staticImageType, StaticImages]);
  const cardItems: CoverType[] = useMemo(
    () =>
      searchString === ''
        ? [
            ...(showUploadCard ? [UPLOAD_CARD_ITEM] : []),
            ...(data.length > 1 && showRandom ? [RANDOM_CARD_ITEM] : []),
            ...items,
            ...(!staticImageType ? data : staticImage),
          ]
        : data,
    [data, items, searchString, showRandom, showUploadCard],
  );

  // if (staticImage.length) {
  //   return { cardItems: [...items, ...staticImage], onClickCard };
  // }
  return { cardItems, onClickCard };
};

export default useImageList;
